<template>
  <div>
    <h2>Relatórios</h2>

    <div
      v-for="categoria in categoriasVisiveis"
      :key="categoria.id"
      :id="categoria.id"
      class="mt-6"
    >
      <div class="d-flex flex-wrap align-center mb-4" style="gap: 12px;">
        <v-icon color="primary" large>{{ categoria.icone }}</v-icon>
        <div>
          <h3 class="mb-1">{{ categoria.titulo }}</h3>
          <p class="c-categoria__descricao mb-0">{{ categoria.descricao }}</p>
        </div>
      </div>

      <v-row class="mt-2">
        <v-col
          v-for="relatorio in categoria.relatorios"
          :key="relatorio.rota"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card class="c-card" outlined>
            <v-card-title class="pb-2 c-card__titulo">
              <v-icon class="mr-3 c-card__icone" color="primary">{{ relatorio.icone }}</v-icon>
              {{ relatorio.titulo }}
            </v-card-title>

            <v-card-subtitle class="pt-0">
              {{ relatorio.descricao }}
            </v-card-subtitle>

            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="$router.push(relatorio.rota)">
                Abrir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "RelatoriosHomeView",
  computed: {
    categoriasVisiveis() {
      const hash = (this.$route?.hash || "").toLowerCase();

      if (hash === "#financeiro") {
        return this.categorias.filter((categoria) => categoria.id === "financeiro");
      }

      if (hash === "#comercial") {
        return this.categorias.filter((categoria) => categoria.id === "comercial");
      }

      return this.categorias;
    }
  },
  data() {
    return {
      categorias: [
        {
          id: "financeiro",
          titulo: "Financeiro",
          descricao: "Relatórios financeiros para acompanhamento fiscal, títulos e movimentações.",
          icone: "mdi-cash-register",
          relatorios: [
            {
              titulo: "NF Recebida",
              descricao: "Notas fiscais recebidas com filtros e exportação.",
              rota: "/relatorios/nf-recebida",
              icone: "mdi-file-document-outline"
            },
            {
              titulo: "NF Emitida",
              descricao: "Notas fiscais emitidas com visão consolidada.",
              rota: "/relatorios/nf-emitida",
              icone: "mdi-receipt-text-outline"
            },
            {
              titulo: "Movimento Financeiro",
              descricao: "Entradas, saídas e saldo de movimentações financeiras.",
              rota: "/relatorios/movimento-financeiro",
              icone: "mdi-cash-multiple"
            },
            {
              titulo: "Contas a Pagar",
              descricao: "Posição e detalhes de títulos a pagar.",
              rota: "/relatorios/contas-a-pagar",
              icone: "mdi-cash-clock"
            },
            {
              titulo: "Contas a Receber",
              descricao: "Títulos a receber e situação de recebimentos.",
              rota: "/relatorios/contas-a-receber",
              icone: "mdi-bank-transfer-in"
            },
            {
              titulo: "Estoque",
              descricao: "Movimentação e saldo de itens em estoque.",
              rota: "/relatorios/estoque",
              icone: "mdi-warehouse"
            }
          ]
        },
        {
          id: "comercial",
          titulo: "Comercial",
          descricao: "Relatórios operacionais e comerciais para acompanhamento de orçamento, job e OS.",
          icone: "mdi-briefcase-outline",
          relatorios: [
            {
              titulo: "Solicitação de Orçamento",
              descricao: "Relatório de solicitação de orçamento.",
              rota: "/relatorios/comercial/sales-order",
              icone: "mdi-file-table-outline"
            },
            {
              titulo: "Relatório de Job",
              descricao: "Relatório de Job.",
              rota: "/relatorios/comercial/job",
              icone: "mdi-briefcase-outline"
            },
            {
              titulo: "Relatório de OS",
              descricao: "Relatório de Ordem de Serviço.",
              rota: "/relatorios/comercial/os",
              icone: "mdi-clipboard-text-outline"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.c-card {
  height: 100%;
}

.c-card__titulo {
  min-height: 72px;
}

.c-card__icone {
  font-size: 34px !important;
}

.c-categoria__descricao {
  color: rgba(0, 0, 0, 0.6);
}
</style>
